'use strict'

var factorySpace = require('./factory-space.js')

var lineEnding = {
  name: 'lineEnding',
  tokenize: tokenizeLineEnding
}

function tokenizeLineEnding(effects, ok) {
  return start

  function start(code) {
    effects.enter('lineEnding')
    effects.consume(code)
    effects.exit('lineEnding')
    return factorySpace(effects, ok, 'linePrefix')
  }
}

module.exports = lineEnding



//////////////////
// WEBPACK FOOTER
// ./node_modules/micromark/dist/tokenize/line-ending.js
// module id = 1514
// module chunks = 0